import dayjs from "dayjs";

import { getPaymentPeriodError } from "./paymentPeriod";

interface RegistrationLoanValues {
  loan_amount?: string | number;
  payment_period?: string | number | null;
  loan_interest_rate_percentage?: string | number | null;
  bought_at?: string | Date | null;
  payment_starts_at?: string | Date | null;
}

export type RegistrationLoanField = "payment_starts_at" | "loan_interest_rate_percentage" | "payment_period";

// ステップ途中と最終登録で同じ条件を確認する。0%と未入力を区別する。
export const getRegistrationLoanErrors = (
  values: RegistrationLoanValues
): Partial<Record<RegistrationLoanField, string>> => {
  const errors: Partial<Record<RegistrationLoanField, string>> = {};
  const periodError = getPaymentPeriodError(values.payment_period, values.loan_amount);
  if (periodError) errors.payment_period = periodError;
  const hasLoan = Number(String(values.loan_amount ?? "0").replace(/,/g, "")) > 0;
  const rate = values.loan_interest_rate_percentage;
  const emptyRate = rate == null || String(rate).trim() === "";
  if (emptyRate) {
    if (hasLoan) errors.loan_interest_rate_percentage = "借入がある場合は初期金利を入力してください。";
  } else if (!Number.isFinite(Number(rate)) || Number(rate) < 0 || Number(rate) > 100) {
    errors.loan_interest_rate_percentage = "金利を0〜100%で入力してください。";
  }
  if (
    hasLoan &&
    values.bought_at &&
    values.payment_starts_at &&
    dayjs(values.payment_starts_at).isBefore(dayjs(values.bought_at), "month")
  ) {
    errors.payment_starts_at = "初回返済月は購入月以降にしてください。";
  }
  return errors;
};
